$(document).ready(function(){
    //城市滑动
    const citySwiper = new Swiper('.p1Left', {
        //autoplay: true,//可选选项，自动滑动
        navigation: {
            nextEl: '.rightButton',
            prevEl: '.leftButton',
        }
        
    })
    const p2Swiper = new Swiper('.p2Swiper', {
        //autoplay: true,//可选选项，自动滑动
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        // autoplay: true,
        navigation: {
          nextEl: '.rightButton1',
          prevEl: '.leftButton1',
        },
        on: {
          progress: function (progress) {
            for (i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.9 + 1;
              }
              translate = slideProgress * modify * 375 + 'px';
              scale = 1 - Math.abs(slideProgress) / 5;
              zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform('translateX(' + translate + ') scale(' + scale + ')');
              slide.css('zIndex', zIndex);
              slide.css('opacity', 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css('opacity', 0);
              }
            }
          },
          setTransition: function (transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              slide.transition(transition);
            }
          }
        }
        
    })
    
})